export default String.raw`
{% include 'partials/common/date-format.html' -%}	

{% if page.QueryString contains 'tab=executed-complaints' -%}
	{% assign complaints = customer-profile.ComplaintsExecuted -%}
	{% assign noComplaints = translations.NoExecutedComplaints -%}
{% else -%}
	{% assign complaints = customer-profile.ComplaintsActive -%}
	{% assign noComplaints = translations.NoActiveComplaints -%}
{% endif -%}
{% assign complaintString = customer-profile.ComplaintQueryGET -%}
{% assign orderString = customer-profile.OrderQueryGET -%}
{% assign paginationPageNo = complaints.PageNo -%}

<div class="eshop__table-container" data-template="partials/customer-profile/complaints/complaint-details.html">
	<table>
		<colgroup>
			<col style="width:100px">
			<col style="width:400px">
			<col style="width:140px">
			<col style="width:150px">
		</colgroup>
		<thead>
			<tr>
				<th class="id">{{ translations.Number | Capitalize }}</th>
				<th>{{ translations.Product }}</th>
				<th>{{ translations.Order }}</th>
				<th>{{ translations.Date }}</th>
				<th>{{ translations.Status }}</th>
			</tr>
		</thead>
	{% if complaints.TotalItems > 0 -%}
    	{% for complaint in complaints.Complaints -%}
			<tbody>
				<tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ complaint.ComplaintId }}" data-url="{{ page.Url }}?{{ complaintString | H }}={{ complaint.ComplaintId }}&deeper-lvl&tab={% if page.QueryString contains 'tab=executed-complaints' -%}executed{% else -%}active{% endif -%}-complaint-details">
					<td class="id">{{ complaint.ComplaintId }}</td>
					<td>{{ complaint.NameNoHtml }}</td>
					<td>
						<span class="pure-button load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ complaint.OrderId }}" data-url="{{ page.Url }}?{{ orderString | H }}={{ complaint.OrderId }}&deeper-lvl&tab=order-details" data-template="partials/customer-profile/orders/order-details.html">
							{{ complaint.OrderId }}
						</span>
					</td>
					<td>{{ complaint.CreatedDate | Date:dateFormat }}</td>
					<td>
						<div class="state {% if complaint.Status == 1 -%} info-container {% elseif complaint.Status == 0 -%} warning-container {% elseif complaint.Status == 2 -%} success-container {% else -%} danger-container {% endif -%}">
							{{ complaint.StatusText }}
						</div>
					</td>
				</tr>
			</tbody>
	  	{% endfor -%}
	{% endif -%}
	</table>
</div>
{% if complaints.TotalItems > 0 -%}
  	{% include 'partials/common/pagination.html' -%}
{% else -%}
  	<div class="no-data">{{ noComplaints }}</div>
{% endif -%}
`